// oauthService.js
import axios from 'axios';

const tokenEndpoint = `${process.env.REACT_APP_DIC_ADMIN_API}/v1/auth/token`; // ✅ Replace this

export const getAccessToken = async () => {
  const body = new URLSearchParams();
  body.append('grant_type', 'client_credentials');
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const clientSecret = process.env.REACT_APP_CLIENT_SECRET;

  try {
    const response = await axios.post(tokenEndpoint, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + btoa(`${clientId}:${clientSecret}`)
      }
    });

    const token = response.data.accessToken;
    const expiresAt = response.data.accessTokenExpiresAt;

    const parsedTime = Date.parse(expiresAt);
    if (isNaN(parsedTime)) {
      throw new Error('Invalid accessTokenExpiresAt in response');
    }

    sessionStorage.setItem('accessToken', token);
    sessionStorage.setItem('accessTokenExpiresAt', expiresAt);

    return token;
  } catch (error) {
    console.error('Failed to fetch token:', error.response?.data || error.message);
    return null;
  }
};

export const getStoredToken = () => {
  return sessionStorage.getItem('accessToken');
};

export const getValidAccessToken = async () => {
  const token = sessionStorage.getItem('accessToken');
  const expiresAtRaw = sessionStorage.getItem('accessTokenExpiresAt');
  const expiresAt = expiresAtRaw ? new Date(expiresAtRaw).getTime() : 0;

  if (!token || !expiresAt || Date.now() >= expiresAt) {
    return await getAccessToken();
  }

  return token;
};
